import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AppRuntimeConfig } from '../../../environments/environment.model';

@Injectable()
export  class ConfigProvider {
  item: AppRuntimeConfig | null = null;

  constructor() {
  }
/**
 * Leitura da configuração
 */
  getConfig(){
    this.item = environment.appConfig;
    return Promise.resolve(this.item);
  }


  
}
